import React from 'react';
import PropTypes from 'prop-types';
import QueueAnim from 'rc-queue-anim';
import { Element } from 'rc-scroll-anim';
import BannerImage from './BannerImage';
import { assets } from './data';
import RequestAccess from '../../Component/RequestAccess';

class Banner extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    navToShadow: PropTypes.func,
  }
  static defaultProps = {
    className: 'banner',
  }
  render() {
    const { className, isMobile, navToShadow } = this.props;
    return (
      <Element component="section" className={`${className}-wrapper page`} onChange={navToShadow}>
        <div className={className}>
          <QueueAnim
              type={isMobile ? 'bottom' : 'right'}
              className={`${className}-text-wrapper ml-5`}
              delay={300}
          >
            <h1 key="h1">CREATE MULTILINGUAL CONTENT</h1>
            <p className="main-info" key="p">
              PARADI DROP TRANSLATES AND TRANSFORMS YOUR VIDEO & AUDIO CONTENT FOR A GLOBAL AUDIENCE
            </p>
            <RequestAccess/>
          </QueueAnim>
          <div className={`${className}-img-wrapper`}>
            {isMobile ?
              <img width="100%" src={`${assets}/image/home/intro-landscape-3a409.svg`} alt="" />
              :
              <BannerImage />}
          </div>
        </div>
      </Element>
    );
  }
}

export default Banner;
